import Immutable from 'immutable';

import { SET_COURSE_PORTFOLIO_DEFAULT } from './actions';

export function CurrentCoursePortfolio(state = Immutable.Map(), action) {
  switch (action.type) {
    case SET_COURSE_PORTFOLIO_DEFAULT: {
      const { coursePath, isAllowed } = action;

      return state.setIn([coursePath, 'portfolioAllowed'], isAllowed);
    }
    default: {
      return state;
    }
  }
}
